export default __webpack_public_path__ + "static/media/twitter_icon.5d3a2c55.png";